export default __webpack_public_path__ + "images/YT.e21a162.png";